/* ============================================
   LUXIRE THEME — base.js
   Global namespace. Component JS files register on window.Luxire.
   ============================================ */

var Luxire = Luxire || {};
